import { useNavigate, useParams } from "react-router-dom";
import EventForm from "./modules/EventForm";
import { useGetSingleEventQuery } from "../../../store/admin/eventSlice";
import useEventActions from "./useEventActions";
import { PageTitleWithNav } from "../modules/PageHeaders";
import { useState } from "react";

export default function EditEventCalendar() {
  const { updateEvent } = useEventActions();
  const navigate = useNavigate();
  const { id } = useParams();
  const { error, data = {}, isLoading } = useGetSingleEventQuery(id);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleFormSubmit = async (formikValues) => {
    setIsUpdating(true);
    try {
      await updateEvent(formikValues);
      navigate(-1);
    } catch (error) {
      console.error("Failed to update event:", error);
    } finally {
      setIsUpdating(false);
    }
  };

  if (error) {
    console.log(error);
  }

  return (
    <>
      {isLoading ? (
        <div className="py-4">
          <h2>Loading...</h2>
        </div>
      ) : (
        <section className="px-lg-3 min-vh-100 pb-5 mb-5">
          <PageTitleWithNav
            title={"Edit"}
            highlightText={data?.name}
            action={() => navigate(-1)}
          />
          <EventForm
            initialFormValues={data}
            onNext={handleFormSubmit}
            btnText="Update Event"
            isLoading={isUpdating}
          />
        </section>
      )}
    </>
  );
}
